import { BookOurService } from "shared/sections";
import { LocationDetailsSection } from "./components";

import "./styles.scss";

const ContactUs = () => (
  <>
    <LocationDetailsSection />
    <BookOurService />
  </>
);

export default ContactUs;
